import React from 'react';
import {createValue} from './utils';
import {Select} from "antd";

export const CustomSelect = ({onChange, ...props}) => {
  return (
    <Select
      {...props}
      onChange={value => onChange(createValue(props.name, value))}
    />
  );
};
